import React from 'react';
import { FirstStep, SecondStep } from '@/components/sku/CreateSku';
import { useSKUStore } from '@/stores/skuStore';
import { SkuContext } from '@/contexts/skuContext';
import CreationPage from '@/components/commos/CreationPage';
import { Button } from '@ab-inbev-maz/compass';

const items = [
  {
    id: 'image',
    title: 'Carga de imagen de SKU',
    Component: () => <FirstStep />
  },
  {
    id: 'form',
    title: 'Información general del SKU',
    Component: () => <SecondStep />
  }
]

const SKUPage: React.FC = () => {
  const saveSingleSKU = useSKUStore(state => state.saveSingleSKU);

  const saveButton = (isDisabled: boolean, isFetching: boolean) => (
    <Button
      key="save-button"
      label="Guardar nuevo SKU"
      rightIcon="functionalities/save"
      variant="primary"
      disabled={isDisabled || isFetching}
      type="submit"
      form="sku-general-info"
    />
  );

  const pageConfig = {
    title: "Creación de SKU",
    description: "Crea aquí los SKUs de tus nuevos productos.",
    tablePath: "/skus/table"
  };

  const modalConfig = {
    title: '¿Confirmar la creación de nuevo SKU?',
    message: 'Estás a punto de crear un nuevo SKU. Una vez guardado, quedará almacenado en la Listado de SKUs.',
    successText: 'SKU guardado exitosamente',
    successMessage: (fileName?: string) => `El SKU "${fileName}" ha sido guardado en la librería`,
    errorText: 'Error al guardar SKU'
  };

    return (
      <CreationPage
        saveButton={saveButton}
        pageConfig={pageConfig}
        modalConfig={modalConfig}
        items={items}
        saveFunction={saveSingleSKU}
        ContextProvider={SkuContext}
      />
    );
};

export default SKUPage;
